import { Component, Injector, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * PropertyRating Widget
 */
@Component({
  selector: 'property-rating-widget',
  templateUrl: './property-rating-widget.component.html',
  styleUrls: ['../../common/css/general.scss', './property-rating-widget.component.scss']
})
export class PropertyRatingWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'propertyRating', false);
  }

  /**
   * Widget's text area options (if used)
   */
  textAreaOptions: any = null;

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready

    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler("propertyRating", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    if (!this.widgetConfig.hashtagSupported) {
      this.widgetConfig.hashtagSupported = true;
    }
    this.loadReflist('ref_l2_property_rating');

    this.mockupData$ = this.widgetService.loadMockup('propertyRating').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('propertyRating', this.getReport()).pipe();
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  /**
   * Called by base class to inform widget about save action result
   * @param _success {boolean} The result of save action
   * @param _err {any} The error object, if save action failed
   */
  saveCompleted(_success: boolean, _err: any = null): void {
    //do something if error
  }

}
